import { getScrollParent } from './scroll_parent'

/*
 * Returns whether the element is fully inside the viewport
 * Note: This assumes the element is not larger than the viewport. And also that the element is not inside a scrollable container.
 */
export function inViewport(el) {
  const viewPortHeight =
    window.innerHeight || document.documentElement.clientHeight
  const boundingRect = el.getBoundingClientRect()
  return boundingRect.top > 0 && boundingRect.bottom < viewPortHeight
}

/*
 * Returns whether the element is inside the viewport from the top (i.e the top edge of element is visible)
 * Note: This assumes that the element is not inside a scrollable container.
 */
export function inViewportFromTop(el) {
  const viewPortHeight =
    window.innerHeight || document.documentElement.clientHeight
  const boundingRect = el.getBoundingClientRect()
  return boundingRect.top > 0 && boundingRect.top < viewPortHeight
}

/*
 * Returns whether the element is inside the viewport of a parent container
 */
export function inViewPortOfContainer(el, container) {
  const boundingRect = el.getBoundingClientRect()
  const containerBoundingRect = container.getBoundingClientRect()

  return (
    boundingRect.top >= containerBoundingRect.top &&
    boundingRect.bottom <= containerBoundingRect.bottom
  )
}

/*
 * Returns the % of the element that is inside the viewport
 * Note: This will handle the case where the element is inside a scrollable container.
 */
export function percentageInViewportOfClosestScrollParent(el) {
  const scrollParent = getScrollParent(el)
  const boundingRect = el.getBoundingClientRect()
  const scrollParentBoundingRect = scrollParent.getBoundingClientRect()

  const bottomEdge = Math.min(
    boundingRect.bottom,
    scrollParentBoundingRect.bottom
  )
  const topEdge = Math.max(boundingRect.top, scrollParentBoundingRect.top)
  const height = bottomEdge - topEdge
  const percentageOfHeight = Math.max(0, height / boundingRect.height) * 100
  return percentageOfHeight
}
